import { render, staticRenderFns } from "./UserManagerAddUser.vue?vue&type=template&id=f47bf10a&scoped=true"
import script from "./UserManagerAddUser.vue?vue&type=script&lang=js"
export * from "./UserManagerAddUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47bf10a",
  null
  
)

export default component.exports